import { getLatestMintedGangsters, getLatestTokenListing } from "api/api";

export const FETCH_LATEST_GANGSTERS_REQUEST = "FETCH_LATEST_GANGSTERS";
export const FETCH_LATEST_GANGSTERS_RECIEVED =
  "FETCH_LATEST_GANGSTERS_RECIEVED";
export const FETCH_LATEST_GANGSTERS_FAIL = "FETCH_LATEST_GANGSTERS_FAIL";

export const FETCH_LATEST_MINTED_GANGSTERS_REQUEST =
  "FETCH_LATEST_MINTED_GANGSTERS_REQUEST";
export const FETCH_LATEST_MINTED_GANGSTERS_RECIEVED =
  "FETCH_LATEST_MINTED_GANGSTERS_RECIEVED";
export const FETCH_LATEST_MINTED_GANGSTERS_FAIL =
  "FETCH_LATEST_MINTED_GANGSTERS_FAIL";

export const fetchLatestGangstersRecieved = (data) => {
  return {
    type: FETCH_LATEST_GANGSTERS_RECIEVED,
    data: data,
  };
};

export const fetchLatestGangstersFail = (error) => {
  return {
    type: FETCH_LATEST_GANGSTERS_FAIL,
    error: error,
  };
};

export const fetchLatestGangstersData = (page) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_LATEST_GANGSTERS_REQUEST });

      const response = await getLatestTokenListing(page);

      dispatch(fetchLatestGangstersRecieved(response.data.tokens));
    } catch (error) {
      dispatch(fetchLatestGangstersFail(error));
    }
  };
};

export const fetchLatestMintedGangsterRecieved = (data) => {
  return {
    type: FETCH_LATEST_MINTED_GANGSTERS_RECIEVED,
    data: data,
  };
};

export const fetchLatestMintedGangstersError = (error) => {
  return {
    type: FETCH_LATEST_MINTED_GANGSTERS_FAIL,
    error: error,
  };
};

export const fetchLatestMintedGangstersData = (page) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_LATEST_MINTED_GANGSTERS_RECIEVED });

      const response = await getLatestMintedGangsters(page);

      dispatch(fetchLatestMintedGangsterRecieved(response.data.tokens));
    } catch (error) {
      dispatch(fetchLatestMintedGangstersError(error));
    }
  };
};
